module.exports = __webpack_public_path__ + "img/sld_scb_6_green.8882c659.svg";